$(document).ready(function () {
    scrollToTopOnMobile()
});

function isTouchDevice() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}

function scrollToTopOnMobile() {
    if (window.innerWidth < 768) {
        const topElement = document.getElementById("top");

        if (topElement) {
            topElement.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }
    }
}

// Avoid `console` errors in browsers that lack a console.
(function () {
    var method;
    var noop = function () {
    };
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeline', 'timelineEnd', 'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});
    while (length--) {
        method = methods[length];
// Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());